import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const articles = [
  {
    title: 'How to talk about the elephant in the room',
    description: 'David Livermore\'s guide on addressing difficult topics in the workplace',
    url: 'https://davidlivermore.com/2022/04/08/how-to-talk-about-the-elephant-in-the-room/'
  },
  {
    title: 'How to Talk with Your Team About The Elephant in the Room',
    description: 'Lisa Zigarmi and Julie Diamond\'s HBR article on team communication',
    url: 'https://hbr.org/2023/01/how-to-talk-with-your-team-about-the-elephant-in-the-room'
  }
];

const tools = [
  {
    title: 'How to use non-violent communication',
    description: 'Dave Bailey\'s framework for effective communication during difficult conversations',
    url: 'https://www.dave-bailey.com/blog/nonviolent-communication'
  }
];

const templates = [
  {
    title: 'High Performance Behaviours (CharlieHR)',
    description: 'A comprehensive template for defining and measuring high-performance behaviors',
    url: 'https://www.notion.so/High-Performance-Behaviours-CharlieHR-14e4150f91a34221959b597f255b8d48?pvs=21'
  },
  {
    title: 'Values & behaviours (Juro)',
    description: 'Juro\'s template for aligning values with observable behaviors',
    url: 'https://www.notion.so/Values-behaviours-Juro-d3a59eeff28b4c7796c33c0d1dacceef?pvs=21'
  },
  {
    title: 'Remote.com list & document anti-behaviours',
    description: 'A practical example of documenting anti-behaviors against company values',
    url: 'https://www.notion.so/d43475e8895c4b7c811490aef64782b3?pvs=21'
  }
];

const ResettingBehavioursUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Articles & Guides" 
            items={articles} 
            icon={BookOpenIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Tools & Frameworks" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard className="md:col-span-2">
          <ResourceList 
            title="Templates & Examples" 
            items={templates} 
            icon={BookmarkIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default ResettingBehavioursUsefulResources; 